function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { LEVEL_SIZE } from '@govuk-react/constants';
import Header from '.';
export var H1 = function H1(props) {
  return React.createElement(Header, _extends({
    level: 1,
    size: LEVEL_SIZE[1]
  }, props));
};
export var H2 = function H2(props) {
  return React.createElement(Header, _extends({
    level: 2,
    size: LEVEL_SIZE[2]
  }, props));
};
export var H3 = function H3(props) {
  return React.createElement(Header, _extends({
    level: 3,
    size: LEVEL_SIZE[3]
  }, props));
};
export var H4 = function H4(props) {
  return React.createElement(Header, _extends({
    level: 4,
    size: LEVEL_SIZE[4]
  }, props));
};
export var H5 = function H5(props) {
  return React.createElement(Header, _extends({
    level: 5,
    size: LEVEL_SIZE[5]
  }, props));
};
export var H6 = function H6(props) {
  return React.createElement(Header, _extends({
    level: 6,
    size: LEVEL_SIZE[6]
  }, props));
};
//# sourceMappingURL=presets.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/header/es/presets.js
// module id = 157
// module chunks = 0